import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Play } from 'lucide-react';
import { useCourse } from '../hooks/useCourse';

export function LessonList() {
  const { courseId } = useParams<{ courseId: string }>();
  const { course, isLoading } = useCourse(courseId || '');

  if (isLoading || !course) {
    return <div className="loading">Laden...</div>;
  }

  return (
    <div className="lesson-list-view">
      <Link to={`/course/${courseId}`} className="back-link">
        <ArrowLeft size={18} />
        Zurück zum Kurs
      </Link>

      <h1>Lektionen</h1>
      <p className="lesson-list-subtitle">{course.lessons.length} Audio-Lektionen</p>

      <div className="lesson-list">
        {course.lessons.map((lesson) => (
          <Link
            key={lesson.id}
            to={`/course/${courseId}/lessons/${lesson.id}`}
            className="lesson-card"
          >
            <div className="lesson-play-icon">
              <Play size={20} />
            </div>
            <div className="lesson-info">
              <h3>{lesson.title}</h3>
              <p>
                {lesson.audioFiles.length === 1
                  ? '1 Audio-Track'
                  : `${lesson.audioFiles.length} Audio-Tracks`}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
